import { PodcastsPage } from "./PodcastsPage";

export default PodcastsPage;
